import { Button, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import type {
	MovementAction,
	MovementOperatorRow,
} from '../../../../redux/api/material-movements';
import {
	ACTION_META,
	ACTION_ORDER,
} from '../../../../components/MaterialMovements/movementMeta';

interface OperatorBreakdownProps {
	operators: MovementOperatorRow[];
	onSelect: (id: number) => void;
}

const OperatorBreakdown = ({ operators, onSelect }: OperatorBreakdownProps) => {
	const actions = ACTION_ORDER.filter((action) =>
		operators.some((op) => op.by_action[action])
	);

	const columns: ColumnsType<MovementOperatorRow> = [
		{
			title: 'Operator',
			dataIndex: 'name',
			render: (name: string, row) => {
				const { id } = row;
				if (id === null) return name;
				return (
					<Button type="link" size="small" className="px-0" onClick={() => onSelect(id)}>
						{name}
					</Button>
				);
			},
		},
		...actions.map((action: MovementAction) => ({
			title: ACTION_META[action].label,
			key: action,
			align: 'right' as const,
			render: (_: unknown, row: MovementOperatorRow) =>
				row.by_action[action] ?? <span className="text-neutral-300">—</span>,
		})),
		{
			title: 'Total',
			dataIndex: 'total',
			align: 'right',
			render: (total: number) => <strong>{total}</strong>,
		},
	];

	return (
		<Table
			size="small"
			rowKey={(row) => String(row.id ?? 'unknown')}
			columns={columns}
			dataSource={operators}
			pagination={false}
			scroll={{ x: true }}
		/>
	);
};

export default OperatorBreakdown;
